import React, { useState } from 'react';
import { Loader2, X, Copy, KeyRound } from 'lucide-react';
import api from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const Row = ({ label, value, testid, onCopy }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.15em] text-mahogany/70 mb-1">{label}</div>
    <div className="flex gap-2"><code className="flex-1 min-w-0 break-all bg-white rounded-lg border border-rose/40 px-3 py-2 text-xs text-burgundy" data-testid={testid}>{value}</code>
      <button type="button" onClick={() => onCopy(value)} className="pill-btn-outline !py-1.5 text-xs shrink-0" aria-label={`Copy ${label}`}><Copy className="w-3.5 h-3.5" /></button></div>
  </div>
);

export const StreamSettingsButton = ({ session }) => {
  const { toast } = useToast();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try { const r = await api.post(`/live/room/${session.id}/stream-settings`); setData(r.data); }
    catch (e) { toast({ title: 'Stream settings unavailable', description: e?.response?.data?.detail }); } finally { setBusy(false); }
  };
  const copy = (v) => { navigator.clipboard?.writeText(v); toast({ title: 'Copied' }); };
  return (
    <>
      <button type="button" onClick={open} disabled={busy} className="pill-btn-outline !py-1.5 text-xs" data-testid={`stream-settings-${session.id}`}>{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <KeyRound className="w-3.5 h-3.5" />} Zoom settings</button>
      {data && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={() => setData(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-cream rounded-3xl p-6 max-w-lg w-full space-y-4" data-testid="stream-settings-modal">
            <div className="flex items-center justify-between"><h3 className="font-serif-display text-2xl text-burgundy">Zoom stream settings</h3><button onClick={() => setData(null)} aria-label="Close"><X className="w-5 h-5 text-mahogany" /></button></div>
            <ol className="text-sm text-burgundy/85 list-decimal list-inside space-y-1">
              <li>In the Zoom meeting: <strong>More (…) → Live on Custom Live Streaming Service</strong>.</li>
              <li>Paste the values below, then <strong>Go Live</strong>.</li>
              <li>Members watch at the page URL below; the recording appears there after you end.</li>
            </ol>
            <Row label="Streaming URL" value={data.rtmp_url} testid="stream-rtmp-url" onCopy={copy} />
            <Row label="Streaming key (keep private)" value={data.stream_key} testid="stream-key" onCopy={copy} />
            <Row label="Live streaming page URL" value={`${window.location.origin}${data.watch_page}`} testid="stream-watch-page" onCopy={copy} />
          </div>
        </div>
      )}
    </>
  );
};

export default StreamSettingsButton;
